var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../../strings/i18n/i18n';
import styled from 'styled-components';
import { fontWeights, spacing } from 'syf-component-library/defaultTheme';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { getLanguageFromStorage } from 'syf-js-utilities';
var TableHeaderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding-right: ", "px;\n  padding-right: ", ";\n  justify-content: space-between;\n  align-items: center;\n  height: 72px;\n  padding-left: ", ";\n"], ["\n  display: flex;\n  padding-right: ", "px;\n  padding-right: ", ";\n  justify-content: space-between;\n  align-items: center;\n  height: 72px;\n  padding-left: ", ";\n"])), spacing.large, function (_a) {
    var $isMobile = _a.$isMobile;
    return "".concat($isMobile ? spacing.medium : spacing.large, "px");
}, function (_a) {
    var $isMobile = _a.$isMobile;
    return "".concat($isMobile ? 84 : 104, "px");
});
var HeaderInnerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var ColumnHeaderText = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  font-weight: ", ";\n"], ["\n  ", ";\n  font-weight: ", ";\n"])), function (_a) {
    var $language = _a.$language;
    return $language === 'en' && 'overflow-wrap: anywhere';
}, fontWeights.bold);
var CreditIssuedHeader = styled(ColumnHeaderText)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 56px;\n"], ["\n  width: 56px;\n"])));
var DescriptionHeader = styled(ColumnHeaderText)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: ", "px;\n"], ["\n  margin-left: ", "px;\n"])), spacing.large);
var CreditAmountHeader = styled(ColumnHeaderText)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: ", "px;\n  text-align: right;\n"], ["\n  width: ", "px;\n  text-align: right;\n"])), function (_a) {
    var $language = _a.$language;
    return ($language === 'en' ? 68 : 80);
});
var AccountCreditsTableHeader = function () {
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var language = getLanguageFromStorage();
    return (_jsxs(TableHeaderContainer, __assign({ "data-cy": "account-credits-table-header", "$isMobile": isLessThanTablet }, { children: [_jsxs(HeaderInnerContainer, { children: [_jsx(CreditIssuedHeader, __assign({ "$language": language }, { children: t('questionnaire.creditIssued') })), !isLessThanTablet && (_jsx(DescriptionHeader, __assign({ "$language": language }, { children: t('questionnaire.description') })))] }), _jsx(CreditAmountHeader, __assign({ "$language": language }, { children: t('questionnaire.creditAmount') }))] })));
};
export default AccountCreditsTableHeader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map